import { render } from "./ProjectSelectDropdown.vue?vue&type=template&id=60a7a31d"
import script from "./ProjectSelectDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectSelectDropdown.vue?vue&type=script&lang=js"

import "./ProjectSelectDropdown.vue?vue&type=style&index=0&id=60a7a31d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/ProjectSelectDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60a7a31d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60a7a31d', __exports__)) {
    api.reload('60a7a31d', __exports__)
  }
  
  module.hot.accept("./ProjectSelectDropdown.vue?vue&type=template&id=60a7a31d", () => {
    api.rerender('60a7a31d', render)
  })

}


export default __exports__